// Load any Google Font by family name, on demand
const loaded = new Set();
const cssUrl = (name, weights = true) =>
  `https://fonts.googleapis.com/css2?family=${encodeURIComponent(name.trim()).replace(/%20/g, "+")}${weights ? ":wght@400;600;700;800" : ""}&display=swap`;

export const FONT_RX = /^[A-Za-z0-9 ]{2,40}$/;

export function loadFont(name) {
  const n = (name || "").trim();
  if (!n || !FONT_RX.test(n) || loaded.has(n)) return;
  loaded.add(n);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = cssUrl(n);
  link.dataset.gfont = n;
  // Some families lack the bold weights — fall back to the default weight
  link.onerror = () => { link.onerror = null; link.href = cssUrl(n, false); };
  document.head.appendChild(link);
}

export const fontStyle = (name) => {
  const n = (name || "").trim();
  if (!n) return undefined;
  loadFont(n);
  return { fontFamily: `"${n}", system-ui, sans-serif` };
};

// Resolves true if Google Fonts knows this family (a stylesheet link errors on unknown names)
export function fontExists(name) {
  const n = (name || "").trim();
  if (!FONT_RX.test(n)) return Promise.resolve(false);
  return new Promise((resolve) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.media = "print";
    link.href = cssUrl(n, false);
    const done = (ok) => { link.remove(); resolve(ok); };
    link.onload = () => done(true);
    link.onerror = () => done(false);
    document.head.appendChild(link);
  });
}

export const POPULAR_FONTS = [
  "Poppins", "Montserrat", "Playfair Display", "Lora", "Merriweather", "Raleway", "Nunito", "Quicksand",
  "Fredoka", "Baloo 2", "Pacifico", "Lobster", "Caveat", "Dancing Script", "Bebas Neue", "Oswald",
  "Abril Fatface", "DM Serif Display", "Libre Baskerville", "Work Sans", "Rubik", "Bricolage Grotesque",
  "Chewy", "Amatic SC", "Permanent Marker", "Creepster", "Mountains of Christmas", "Comfortaa",
];
